module.exports = __webpack_public_path__ + "h5/img/baokuan.3957702a.png";